import SbService from '@/api/SbService.js'
import Vue from 'vue'
export const sb1Module = {
  namespaced: true,
  state: () => ({
    sb1Data: [],
    sb1LoadStatus: 'request',
    paginationSb1StateParams: {
      count: 0,
      limit: 1000,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationSb1StateParams.total /
        state.paginationSb1StateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.sb1Data = [...data]
    },

    edit_multiple(state, data) {
      let indexed = state.sb1Data.findIndex(
        (x) => x.book_contacts__id == data.id
      )
      Object.assign(state.sb1Data[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.sb1Data.findIndex((x) => x.book_contacts__id == id)
      state.sb1Data.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationSb1StateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.sb1LoadStatus = 'request'
    },
    load_success(state) {
      state.sb1LoadStatus = 'success'
    },
    load_error(state) {
      state.sb1LoadStatus = 'error'
    }
  },
  actions: {
    getSb1All({ commit }, params) {
      commit('load_request')

      SbService.getSb1All(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    editSb1Multiple({ commit }, { id, dataEdit }) {
      SbService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteSb1Data({ commit }, id) {
      // commit("load_request");
      SbService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
